export enum PAGES {
    ROOT = "/",
    CHANGE_EMAIL = "/change-email",
    CHANGE_PASSWORD = "/change-password",
    CREDENTIALS = "/credentials",
    GENERATE = "/generate",
    LOGIN = "/login",
    RECOVER = "/recover",
    SIGNUP = "/signup",
    TWO_FACTOR_SETUP = "/two-factor/setup",
    TWO_FACTOR_VERIFY = "/two-factor/verify",
    TWO_FACTOR_RECOVER = "/two-factor/recover",
    VERIFY = "/verify",
    SHARED_ALBUMS = "/shared-albums",
}
